import { render, staticRenderFns } from "./Slots.vue?vue&type=template&id=b9f7ba1e&scoped=true&"
import script from "./Slots.vue?vue&type=script&lang=js&"
export * from "./Slots.vue?vue&type=script&lang=js&"
import style0 from "./Slots.vue?vue&type=style&index=0&id=b9f7ba1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9f7ba1e",
  null
  
)

export default component.exports